var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M8 1L13.1962 7.75H2.80385L8 1Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M8 16L13.1962 9.25H2.80385L8 16Z",
    fill: "#DEE2E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sorting-icon.f0700928d9bbbac3b42219c8910810d1.svg";
export { ForwardRef as ReactComponent };